import { Col } from "react-bootstrap";
import gh from '../assets/img/github.svg'
import yt from '../assets/img/youtube.svg';

export const ProjectCard = ({ title, description, imgUrl, github, deploy, demo }) => {
  return (
    <Col size={15} sm={6} md={4}>
      <div className="proj-imgbx">
        <img src={`/projects/${imgUrl}.png`} alt="bg" />
        <div className="proj-txtx">
          <h4>{title}</h4>
          <div>{description}</div>
          <br />
          <div className="social-icon">
            {github &&
              <a target="_blank" rel="noopener noreferrer" href={github}><img src={gh} alt="GH" /></a>
            }
            {demo &&
              <a target="_blank" rel="noopener noreferrer" href={demo}><img src={yt} alt="YT" /></a>
            }
            <br />
            {deploy &&
              <button onClick={() => window.open(deploy)} className="vl-but"><span>View Live</span></button>
            }
          </div>
        </div>
      </div>
    </Col>
  )
}
